import { gql } from '@apollo/client';

/** ТЗ 0074 (доработка): save the LMS suspension settings (partial input). */
export const SaveLmsBlockSettingsMutationDocument = gql`
  mutation StoreLmsBlockSettings($input: LmsBlockSettingsInput!) {
    saveLmsBlockSettings(input: $input) {
      success
      settings {
        robotEnabled
        overdueDays
        mailEnabled
        slackEnabled
        smsEnabled
        suspendedTemplateId
        suspendedTemplateName
        restoredTemplateId
        restoredTemplateName
        updatedAt
        updatedByName
        serverRobotAllowed
        serverMailAllowed
        serverSlackAllowed
        serverSmsAllowed
        canEdit
      }
      customErrors {
        field
        code
        message
      }
    }
  }
`;

/** ТЗ 0074 (доработка): send a template with example data to the caller. */
export const SendLmsBlockTestEmailMutationDocument = gql`
  mutation TryLmsBlockTemplate($kind: String!, $templateId: String) {
    sendLmsBlockTestEmail(kind: $kind, templateId: $templateId) {
      success
      sentTo
      customErrors {
        field
        code
        message
      }
    }
  }
`;
